var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeginner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13033 0.413133C6.41158 -0.149367 7.20846 -0.12593 7.46627 0.413133L9.01314 3.53032L12.435 4.02251C13.0444 4.11626 13.2788 4.86626 12.8335 5.31157L10.3725 7.72563L10.9585 11.1241C11.0522 11.7334 10.396 12.2022 9.85689 11.9209L6.81002 10.3038L3.73971 11.9209C3.20064 12.2022 2.54439 11.7334 2.63814 11.1241L3.22408 7.72563L0.763145 5.31157C0.317832 4.86626 0.552207 4.11626 1.16158 4.02251L4.60689 3.53032L6.13033 0.413133Z",
    fill: "#CE741C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginner);
export default __webpack_public_path__ + "static/media/beginner.a720575ba82d76bfc2d5b94ec1532f10.svg";
export { ForwardRef as ReactComponent };